<template>
  <b-container>
    <h1 class="text-center pt-4 pb-4">{{ $t("title.taskManagement") }}</h1>

      <b-row class="mt-4">
        <b-col sm="4">
          <b-form-select
            v-model="taskItem"
            :options="taskItems"
          ></b-form-select>
        </b-col>
      </b-row>

    <div v-if="taskItem === 'bucket'">
        <BucketTable :type="taskItem"/>
    </div>
    <div v-if="taskItem === 'label'">
        <LabelTable :type="taskItem"/>
    </div>

    <div v-if="spinner" class="text-center">
      <b-spinner
        style="width: 3rem; height: 3rem"
        class="spinner"
        variant="success"
        label="Spinning"
        disabled="labelStatus"
      ></b-spinner>
    </div>

    <div v-if="error" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ error }}</p>
      </b-alert>
    </div>
  </b-container>
</template>

<script>
//import axios from "axios";
import { globalF } from "../../Helpers";
import BucketTable from "./TaskManagementTable.vue";
import LabelTable from "./TaskManagementTable.vue";

export default {
  mixins: [globalF],
  data() {
    return {
      error: "",
      taskItem: null,
      spinner: false,
    };
  },
  mounted() {},
  computed: {
    taskItems() {
      return [
        { value: null, text: this.$t("action.choose") },
        { value: "bucket", text: this.$t("label.bucketList") },
        { value: "label", text: this.$t("label.labelList") },
      ]
    },
  },
  methods: {},
  components: {
    BucketTable,
    LabelTable
  },
};
</script>
